import { Sheets } from "common/sheets";
export class Hand {
    constructor(sheets) {
        this.sprite = Sheets.sprite(sheets, "할아버지 손.png");
    }
}
//# sourceMappingURL=hand.js.map